import * as React from "react";
import { useContext, useEffect, useMemo, useState } from "react";
import { tokens, ColorModeContext } from "../../../../theme";
import { useNavigate, useSearchParams } from "react-router-dom";
import {
  Box,
  Button,
  Divider,
  Grid,
  Paper,
  Stack,
  TextField,
  Typography,
  Chip,
  CircularProgress,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  IconButton,
  Tabs,
  Tab,
  useTheme,

  // ✅ NEW imports for radio + card UI
  Card,
  CardContent,
  CardActions,
  FormControl,
  FormControlLabel,
  Radio,
  RadioGroup,
  //new added
 

} from "@mui/material";

import Autocomplete from "@mui/material/Autocomplete";
import { DataGrid,useGridApiContext,GridEditSingleSelectCell} from "@mui/x-data-grid";
import Checkbox from "@mui/material/Checkbox";
import {Select,MenuItem} from "@mui/material";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import AddIcon from "@mui/icons-material/Add";

import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";

import ConnString from "../../../../ConnString.js";

const Connstring2 = ConnString.connstring;

// helpers
const formatISODateInput = (d) => {
  if (!d) return "";
  const dt = new Date(d);
  if (Number.isNaN(dt.getTime())) return "";
  return dt.toISOString().slice(0, 10);
};

const uid = () => `${Date.now()}_${Math.random().toString(16).slice(2)}`;

const emptyLine = (idx = 1) => ({
  // id: `${Date.now()}-${idx}`,
  id: uid(), 
  LineNo: idx,
  InvoiceNo: "",
  InvoiceDate: "",
  InvoiceAmount: 0,
  AppliedAmount: 0,
  Remarks: "",
});

const emptyHeader = () => ({
  RecID: null,
  TransNo: "",
  TransDate: formatISODateInput(new Date()),
  BranchCode: "",
  PayorID: null,
  PayorName: "",
  PayorInfo: "",
  ReferenceNo: "",
  Remarks: "",
  Status: "Unposted",
  TotalAmount: 0,
  UnappliedAmount: 0,

  // Optional header fields (safe defaults for display)
  InvoicedAmount: 0,
  TaxWithheld: 0,
  DrAdj: 0,
  CrAdj: 0,
});

const fmt2 = (n) =>
  Number(n || 0).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });

const toNumber = (v) => {
  if (v === null || v === undefined || v === "") return 0.00;
  if (typeof v === "number") return v;
  return Number(String(v).replace(/,/g, "")) || 0.00;
};

const isValidDate = (value) => {
  if (!value) return false;
  const date = value instanceof Date ? value : new Date(value);
  return !Number.isNaN(date.getTime());
};

export default function CashReceiptTransaction({
  mode: modeProp,
  recid: recidProp,
  selectedBranch: selectedBranchProp,
  onClose,
}) {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  useContext(ColorModeContext);

  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const mode = modeProp || searchParams.get("mode") || "new";
  const recid = recidProp || searchParams.get("recid") || null;
  const selectedBranch = selectedBranchProp || searchParams.get("branch") || null;

  const viewMode = mode === "view";
  const cloneMode = mode === "clone";
  const editMode = ["edit", "view", "clone"].includes(mode);

  const compID = sessionStorage.getItem("compID");
  const userID = sessionStorage.getItem("userID");

  const [loading, setLoading] = useState(false);
  const [saving, setSaving] = useState(false);

  const [header, setHeader] = useState(emptyHeader());
  const [lines, setLines] = useState([emptyLine(1)]);

  // Collection grids from the desktop form. Multiple cash funds and checks are allowed.
  const [cashRows, setCashRows] = useState([]);
  const [checkRows, setCheckRows] = useState([]);

  // ✅ NEW: tender radio selection
  const [tenderType, setTenderType] = useState("CASH"); // CASH | CHECK

  // dialogs
  const [cashDlgOpen, setCashDlgOpen] = useState(false);
  const [checkDlgOpen, setCheckDlgOpen] = useState(false);
  const [cashDlgMode, setCashDlgMode] = useState("add");
  const [checkDlgMode, setCheckDlgMode] = useState("add");
  const [cashEditingId, setCashEditingId] = useState(null);
  const [checkEditingId, setCheckEditingId] = useState(null);

  const [cashForm, setCashForm] = useState({ fund: null, amount: "" });
  const [checkForm, setCheckForm] = useState({
    bankFund: null,     // ✅ new
    bank: null,
    bankBranch: "",
    checkNumber: "",
    checkDate: new Date(),
    amount: "",
    depositDate: new Date(),
  });

  // tabs
  const [tab, setTab] = useState(0);

  // lookups
  const [branchOptions, setBranchOptions] = useState([]);
  const [fundOptions, setFundOptions] = useState([]);
  const [bankOptions, setBankOptions] = useState([]);
  //const [cashFundOptions, setCashFundOptions] = useState([]);
  const [bankFundOptions, setBankFundOptions] = useState([]);


  // payors
  const [payorOptions, setPayorOptions] = useState([]);
  const [payorLoading, setPayorLoading] = useState(false);
  const [payorQuery, setPayorQuery] = useState("");

    // searchitems
  const [itemOptions1, setItemOptions1] = useState([]);
  const [itemLoading1, setItemLoading1] = useState(false);
  const [itemQuery, setItemQuery] = useState("");
  const [vatAtcTaxTypeOptions, setVatAtcTaxTypeOptions] = useState("VAT");  

  // robust branch code
  const selectedBranchCode = useMemo(() => {
    if (!selectedBranch) return "";

    if (typeof selectedBranch === "string") {
      const m = selectedBranch.match(/^\s*\[([^\]]+)\]/);
      return m ? m[1].trim() : selectedBranch.trim();
    }

    return (selectedBranch.BranchCode || selectedBranch.Branch || selectedBranch.id || "").trim();
  }, [selectedBranch]);

  const selectedBranchObj = useMemo(() => {
    const code = header.BranchCode || selectedBranchCode;
    return branchOptions.find((b) => b.BranchCode === code || b.Branch === code) || null;
  }, [branchOptions, header.BranchCode, selectedBranchCode]);

  const branchDisplayName = useMemo(() => {
    if (selectedBranch && typeof selectedBranch === "object") {
      return (
        selectedBranch.LocName ||
        selectedBranch.BranchName ||
        selectedBranch.CompanyName ||
        selectedBranch.name ||
        ""
      );
    }
    return selectedBranchObj?.LocName || selectedBranchObj?.BranchName || "";
  }, [selectedBranch, selectedBranchObj]);

  const selectedPayorObj = useMemo(() => {
    if (!header.PayorID) return null;
    return payorOptions.find((p) => p.PayorID === header.PayorID) || null;
  }, [payorOptions, header.PayorID]);


  // totals
  const cashTotal = useMemo(
    () => cashRows.reduce((sum, r) => sum + (Number(r.CashAmount) || 0), 0),
    [cashRows]
  );
  const checkTotal = useMemo(
    () => checkRows.reduce((sum, r) => sum + (Number(r.CheckAmount) || 0), 0),
    [checkRows]
  );
  const collectedTotal = useMemo(() => cashTotal + checkTotal, [cashTotal, checkTotal]);

  // Keep header.TotalAmount in sync with collectedTotal (since field is disabled)
  useEffect(() => {
    setHeader((prev) => ({
      ...prev,
      TotalAmount: Number(collectedTotal) || 0,
    }));
  }, [collectedTotal]);

  const totals = useMemo(() => {
    const totalApplied = lines.reduce((sum, r) => sum + (Number(r.AppliedAmount) || 0), 0);
    const total = Number(header.TotalAmount) || 0;
    const unapplied = total - totalApplied;
    return { totalApplied, unapplied };
  }, [lines, header.TotalAmount]);

  useEffect(() => {
    setHeader((prev) => ({ ...prev, UnappliedAmount: totals.unapplied }));
  }, [totals.unapplied]);


  const [saleHeader, setSaleHeader] = useState({
  SINo: "",
  SIDate: null,
  DRNo: "",
  DRDate: null,
  AuxNo: "",
  Warehouse: null,
  WithATC: false,
  ATC: null,
  WTaxRate: 0,
  WtaxNature: null
  });




  // columns (applications only)
  const appColumns = useMemo(
    () => [
      { field: "LineNo", headerName: "#", width: 70 },
      { field: "InvoiceNo", headerName: "Invoice No", width: 160, editable: !viewMode },
      { field: "InvoiceDate", headerName: "Invoice Date", width: 130, editable: !viewMode },
      { field: "InvoiceAmount", headerName: "Invoice Amt", width: 130, editable: !viewMode, type: "number" },
      { field: "AppliedAmount", headerName: "Applied Amt", width: 130, editable: !viewMode, type: "number" },
      { field: "Remarks", headerName: "Remarks", width: 220, editable: !viewMode },
    ],
    [viewMode]
  );

  // columns (Sales Invoice only)

  
  const saleColumns = useMemo(
  () => [
    { field: "LineNo", headerName: "#", width: 50 },
    { field: "ItemCode", headerName: "Item Code", width: 80 },
    { field: "Description", headerName: "Description", width: 300, editable: !viewMode },
    { field: "Qty", headerName: "Qty", width: 90, type: "number", editable: !viewMode,background: "yellow" },
    { field: "Unit", headerName: "Unit", width: 90 , textAlign:"center"},
    { field: "UnitPrice", headerName: "Unit Price", width: 130, type: "number" ,editable: !viewMode },
    { field: "Amount", headerName: "Amount", width: 140, type: "number" },

   
   
    { field: "VATable", headerName: "Vatable", width: 80, type: "boolean" ,editable:!viewMode},
    {
        field: "VatCode",
        headerName: "VatCode",
        width: 120,
        editable: !viewMode,
        type: "singleSelect",
       // valueOptions: ["Taxable", "NON-VAT", "Exempt","Zero"],
      //  renderEditCell: (params) => <VATCodeEditCell {...params} />,
        valueOptions: (params) => {
            const vatable =
              params.row?.VATable === true ||
              params.row?.VATable === 1 ||
              params.row?.VATable ===  "yes" ||
              params.row?.VATable === "true";

            return vatable ? ["Taxable", "Exempt", "Zero"] : ["NON-VAT"];
          },

      },
    { field: "VATAmount", headerName: "VAT Amount", width: 100, type: "number" },
    { field: "VATRate", headerName: "VAT Rate", width: 80 },
  
  { field: "VATATC", 
    headerName: "VAT ATC", 
    width: 100 ,
    editable: !viewMode,
    type: "singleSelect",
 
   valueOptions: (params) => {
    const isNonVat =
      params.row?.VatCode === "NON-VAT" ||
      params.row?.VATable === false ||
      params.row?.VATable === 0 ||
      params.row?.VATable === "false" ||
      params.row?.VATable === "no";

      console.log(vatAtcOptionsNonVat);
    return isNonVat ? vatAtcOptionsNonVat : vatAtcOptionsVAT;
  },

  getOptionValue: (opt) => opt.ATC,
  
  getOptionLabel: (opt) =>
  opt?.ATC
  ? `${opt.ATC} - ${opt.Nature ?? ""} (${Number(opt.Taxrate || 0).toFixed(2)}%)`
  : "",

  },
  

    // 🔒 hidden columns

    { field: "NetUnitPrice", headerName: "Net Unit Price", width: 80 },
    { field: "UnitBase", headerName: "Unit Base", width: 80 },
    { field: "UnitFactor", headerName: "Unit Factor", width: 80 },
    { field: "GLCode", headerName: "GLCode", width: 80 },
    { field: "IncomeAccount", headerName: "Income Account", width: 80 },
    { field: "SalesType", headerName: "SalesType", width: 80 },
    { field: "InvCost", headerName: "InvCost", width: 80 },
    { field: "CostPerUnit", headerName: "CostPerUnit", width: 80 },
    { field: "COSGLCode", headerName: "COSGLCode", width: 80 },
    { field: "RegType", headerName: "RegType", width: 80 },
  ],
  [viewMode]
  );

  const saleColumnVisibility = {
    
  NetUnitPrice: false,
  UnitBase: false,
  UnitFactor: false,
  GLCode: false,
  IncomeAccount: false,
  SalesType: false,
  InvCost: false,
  CPU: false,
  COSGLCode: false,
  RegType: false,
  VATable: false,
    CostPerUnit: false,
  };

  const handleDeleteSaleRow = (id) => {
  setSaleLines((prev) => {
    const kept = prev.filter((r) => String(r.id) !== String(id));
    return kept.map((r, idx) => ({ ...r, LineNo: idx + 1 }));
  });
};

const saleColumnsWithDelete = useMemo(() => {
  const deleteCol = {
    field: "__delete__",
    headerName: "",
    width: 50,
    sortable: false,
    filterable: false,
    disableColumnMenu: true,
    editable: false,
    align: "center",
    headerAlign: "center",
    renderCell: (params) => (
      <IconButton
        size="small"
        color="error"
        onClick={(e) => {
          e.stopPropagation(); // prevent row click/edit side-effects
          handleDeleteSaleRow(params.row.id);
        }}
        disabled={viewMode}
      >
        <DeleteIcon fontSize="small" />
      </IconButton>
    ),
  };

  return [deleteCol, ...saleColumns];
}, [saleColumns, viewMode]);


 //for sale of Goods ATC
//const [useATC, setUseATC] = useState(false);
const [atcOptions, setAtcOptions] = useState([]);
const [atcLoading, setAtcLoading] = useState(false);
const [atcQuery, setAtcQuery] = useState(""); // optional search text
 
 
const [warehouseOptions, setWarehouseOptions] = useState([]);
const [warehouseLoading, setWarehouseLoading] = useState(false);
const [warehouseQuery, setWarehouseQuery] = useState(""); // optional search text

  // =============== Add Item Bar state (NEW UX) ===============
  const [itemOpen, setItemOpen] = useState(false);
  const [itemInput, setItemInput] = useState("");
  const [itemOptions, setItemOptions] = useState([]);
  const [itemLoading, setItemLoading] = useState(false);

  const [pickedItem, setPickedItem] = useState(null);
  const [entryQty, setEntryQty] = useState(1);
  const [entryPrice, setEntryPrice] = useState("");
  const [entryVatable, setEntryVatable] = useState(true);
  const [entryVatCode, setEntryVatCode] = useState("");

  const [vatAtcOptions, setVatAtcOptions] = useState([]);  
 
  const [vatAtcOptionsVAT, setVatAtcOptionsVAT] = useState([]);
  const [vatAtcOptionsNonVat, setVatAtcOptionsNonVat] = useState([]);
  const [vatAtcLoading, setVatAtcLoading] = useState(false);



  // -------- API calls --------
  const apiFetchBranches = async () => {
    const response = await fetch(`${Connstring2}/api/userBranchAccess`, {
      method: "POST",
      credentials: "include",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ companyID: compID, currentuserID: userID }),
    });
    return response.json();
  };

  const apiFetchFunds = async ({ fundtype = "On Hand", q = "" }) => {
    const response = await fetch(`${Connstring2}/api/Funds/List`, {
      method: "POST",
      credentials: "include",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        compID,
        fundtype,
        branchCode: header.BranchCode || selectedBranchCode || "",
        q,
      }),
    });
    return response.json();
  };

  const apiFetchBanks = async () => ({ success: true, options: [] });

  const apiLoadTransaction = async (recID) => {
    const response = await fetch(`${Connstring2}/api/CashReceipts/GetByRecID`, {
      method: "POST",
      credentials: "include",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ compID, recid: recID }),
    });
    return response.json();
  };

  const apiSaveTransaction = async (payload) => {
    const response = await fetch(`${Connstring2}/api/CashReceipts/Save`, {
      method: "POST",
      credentials: "include",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload),
    });
    return response.json();
  };

  const apiPostTransaction = async (recID) => {
    const response = await fetch(`${Connstring2}/api/CashReceipts/Post`, {
      method: "POST",
      credentials: "include",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ compID, recid: recID, userID }),
    });
    return response.json();
  };

  const apiUnpostTransaction = async (recID) => {
    const response = await fetch(`${Connstring2}/api/CashReceipts/Unpost`, {
      method: "POST",
      credentials: "include",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ compID, recid: recID, userID }),
    });
    return response.json();
  };

  const apiGetNextTransNo = async ({ compID, branchCode, transType }) => {
    const response = await fetch(`${Connstring2}/api/GetNextTransNo`, {
      method: "POST",
      credentials: "include",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ compID, branchCode, transType }),
    });
    return response.json();
  };

  const apiSearchPayors = async ({ compID, branchCode, q }) => {
    const response = await fetch(`${Connstring2}/api/Payors/Search`, {
      method: "POST",
      credentials: "include",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ compID, branchCode, q }),
    });
    return response.json();
  };


const apiFetchATCMaster = async ({ compID, q = "" }) => {
  const response = await fetch(`${Connstring2}/api/atcmaster`, {
    method: "POST",
    credentials: "include",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ compID, q }),
  });
  return response.json();
};

const apiFetchWarehouseMaster = async ({ compID, branchCode,q = "" }) => {
  const response = await fetch(`${Connstring2}/api/Warehouse`, {
    method: "POST",
    credentials: "include",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ compID,branchCode, q }),
  });
  return response.json();
};

const apiSearchItems = async ({ compID,branchCode, q = "" }) => {
  const response = await fetch(`${Connstring2}/api/searchitems`, {
    method: "POST",
    credentials: "include",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ compID,branchCode, q }),
  });
  return response.json();
};

const apiFetchVATATC = async  ({ compID, taxType, q = "" }) => {
  const res = await fetch(`${Connstring2}/api/vatatc`, {
    method: "POST",
    credentials: "include",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ compID, taxType, q }),
  });
  return res.json();
};

 

  // -------- Initialization --------
  useEffect(() => {
    let alive = true;

    const init = async () => {
      setLoading(true);
      try {
        const [branchData, fundData, bankData] = await Promise.all([
          apiFetchBranches(),
          apiFetchFunds({ fundtype: "On Hand" }),
          apiFetchBanks(),
        ]);

        if (!alive) return;

        setBranchOptions(branchData?.success && Array.isArray(branchData.options) ? branchData.options : []);
        setFundOptions(fundData?.success && Array.isArray(fundData.options) ? fundData.options : []);
        setBankOptions(bankData?.success && Array.isArray(bankData.options) ? bankData.options : []);

        if (editMode) {
          if (!recid) {
            alert("Missing recid.");
            navigate("/App/TLCashReceipts");
            return;
          }

          const data = await apiLoadTransaction(recid);
          if (!alive) return;

          if (!data?.success) {
            alert(data?.message || "Failed to load transaction.");
            navigate("/App/TLCashReceipts");
            return;
          }

          const h = data.header || {};
          const l = Array.isArray(data.lines) ? data.lines : [];
          const cash = Array.isArray(data.cashRows) ? data.cashRows : [];
          const checks = Array.isArray(data.checkRows) ? data.checkRows : [];

          const normalizedHeader = {
            ...emptyHeader(),
            ...h,
            TransDate: formatISODateInput(h.TransDate || h.transDate),
          };

          const normalizedLines =
            l.length > 0
              ? l.map((r, idx) => ({
                  id: r.id ?? r.LineID ?? `${Date.now()}-${idx}`,
                  LineNo: r.LineNo ?? idx + 1,
                  InvoiceNo: r.InvoiceNo ?? "",
                  InvoiceDate: r.InvoiceDate ? formatISODateInput(r.InvoiceDate) : "",
                  InvoiceAmount: Number(r.InvoiceAmount) || 0,
                  AppliedAmount: Number(r.AppliedAmount) || 0,
                  Remarks: r.Remarks ?? "",
                }))
              : [emptyLine(1)];

          const normalizedCash = cash.map((r) => ({
            id: r.id ?? r.RecID ?? uid(),
            FundCode: r.FundCode ?? "",
            FundName: r.FundName ?? "",
            CashAmount: Number(r.CashAmount) || 0,
          }));

          const normalizedChecks = checks.map((r) => ({
            id: r.id ?? r.RecID ?? uid(),
             FundCode: r.FundCode ?? "",     // ✅ add
             FundName: r.FundName ?? "",
            BankCode: r.BankCode ?? "",
            BankName: r.BankName ?? "",
            BankBranch: r.BankBranch ?? "",
            CheckNumber: r.CheckNumber ?? "",
            CheckDate: r.CheckDate ? new Date(r.CheckDate) : null,
            CheckAmount: Number(r.CheckAmount) || 0,
            DepositDate: r.DepositDate ? new Date(r.DepositDate) : null,
          }));

          if (cloneMode) {
            normalizedHeader.RecID = null;
            normalizedHeader.TransNo = "";
            normalizedHeader.Status = "Unposted";
          }

          setHeader(normalizedHeader);
          setLines(normalizedLines);
          setCashRows(normalizedCash);
          setCheckRows(normalizedChecks);
          if (data.saleHeader) {
            setSaleHeader({
              ...data.saleHeader,
              SIDate: data.saleHeader.SIDate ? new Date(data.saleHeader.SIDate) : null,
              DRDate: data.saleHeader.DRDate ? new Date(data.saleHeader.DRDate) : null,
              Warehouse: data.saleHeader.WarehouseCode
                ? { Code: data.saleHeader.WarehouseCode, Description: data.saleHeader.WarehouseName || data.saleHeader.WarehouseCode }
                : null,
              WithATC: Boolean(data.saleHeader.WithATC),
              ATC: data.saleHeader.WTATC
                ? { ATC: data.saleHeader.WTATC, Rate: Number(data.saleHeader.WTRate) || 0, Nature: data.saleHeader.Nature || "" }
                : null,
            });
          }
          setSaleLines((data.saleLines || []).map((row, index) => ({ ...row, id: row.id || uid(), LineNo: index + 1 })));

          // ✅ auto-detect tender type from loaded rows
          if (normalizedChecks.length) setTenderType("CHECK");
          else setTenderType("CASH");
        } else {
          if (selectedBranchCode) {
            setHeader((prev) => ({
              ...prev,
              BranchCode: prev.BranchCode || selectedBranchCode,
            }));
          } else if (branchData?.success && branchData.options?.length) {
            setHeader((prev) => ({
              ...prev,
              BranchCode: prev.BranchCode || branchData.options[0].BranchCode,
            }));
          }
        }
      } catch (e) {
        console.error(e);
        alert("Initialization error. Check console.");
      } finally {
        if (alive) setLoading(false);
      }
    };

    init();
    return () => {
      alive = false;
    };
  }, [editMode, cloneMode, recid, navigate, compID, userID, selectedBranchCode]);

  // New and cloned receipts must receive their own document number.
  useEffect(() => {
    if (!["new", "clone"].includes(mode)) return;
    if (!header.BranchCode) return;
    if (header.TransNo) return;

    let alive = true;

    (async () => {
      try {
        const data = await apiGetNextTransNo({
          compID,
          branchCode: header.BranchCode,
          transType: "ACTCRP",
        });

        if (!alive) return;
        if (!data?.success) return alert(data?.message || "Failed to get TransNo.");

        setHeader((prev) => ({ ...prev, TransNo: data.transNo || "" }));
      } catch (e) {
        console.error(e);
        alert("Error generating TransNo.");
      }
    })();

    return () => {
      alive = false;
    };
  }, [mode, header.BranchCode, header.TransNo, compID]);

  // Payor search (debounced)
  useEffect(() => {
    if (!header.BranchCode) return;

    let cancelled = false;

    const t = setTimeout(async () => {
      setPayorLoading(true);
      try {
        const data = await apiSearchPayors({
          compID,
          branchCode: header.BranchCode,
          q: payorQuery || "",
        });

        if (cancelled) return;

        const opts = data?.success && Array.isArray(data.options) ? data.options : [];
        setPayorOptions(opts);
      } catch (e) {
        console.error(e);
        if (!cancelled) setPayorOptions([]);
      } finally {
        if (!cancelled) setPayorLoading(false);
      }
    }, 300);

    return () => {
      cancelled = true;
      clearTimeout(t);
    };
  }, [compID, header.BranchCode, payorQuery]);
 

   // Item search (debounced)
  useEffect(() => {
    if (!header.BranchCode) return;

    let cancelled = false;

    const t = setTimeout(async () => {
      setItemLoading1(true);
      try {
        const data = await apiSearchItems({
          compID,
          branchCode: header.BranchCode,
          q: itemQuery || "",
        });

        if (cancelled) return;

        const opts = data?.success && Array.isArray(data.options) ? data.options : [];
        setItemOptions1(opts);
      } catch (e) {
        console.error(e);
        if (!cancelled) setItemOptions1([]);
      } finally {
        if (!cancelled) setItemLoading1(false);
      }
    }, 300);

    return () => {
      cancelled = true;
      clearTimeout(t);
    };
  }, [compID, header.BranchCode, itemQuery]);
 

    useEffect(() => {
  if (!header.BranchCode && !selectedBranchCode) return;
  let alive = true;

  (async () => {
    try {
      if (tenderType === "CHECK") {
        const data = await apiFetchFunds({ fundtype: "In Bank" });
        const opts = (data?.success && Array.isArray(data.options)) ? data.options : [];
        if (!alive) return;
        setBankFundOptions(opts);       // ✅ for dropdown
      } else {
        const data = await apiFetchFunds({ fundtype: "On Hand" });
        const opts = (data?.success && Array.isArray(data.options)) ? data.options : [];
        if (!alive) return;
        setFundOptions(opts);           // ✅ cash dialog uses fundOptions
      }
    } catch (e) {
      console.error(e);
      if (!alive) return;
      if (tenderType === "CHECK") setBankFundOptions([]);
      else setFundOptions([]);
    }
  })();

  return () => { alive = false; };
      }, [tenderType, header.BranchCode, selectedBranchCode, compID]);

 
 
  // handlers
  useEffect(() => {
  if (!saleHeader.WithATC) {
    setAtcOptions([]);
    setAtcQuery("");
    setSaleHeader((p) => ({ ...p, ATC: null }));
    return;
  }

  let cancelled = false;

  const t = setTimeout(async () => {
    setAtcLoading(true);
    try {
      const data = await apiFetchATCMaster({ compID, q: atcQuery });
    
      if (cancelled) return;
      setAtcOptions(data?.success ? (data.options || []) : []);
    } catch (e) {
      console.error(e);
      if (!cancelled) setAtcOptions([]);
    } finally {
      if (!cancelled) setAtcLoading(false);
    }
  }, 300);

  return () => {
    cancelled = true;
    clearTimeout(t);
  };
}, [saleHeader.WithATC, compID, atcQuery]);
  
  
 useEffect(() => {
  const branchCode = header.BranchCode || selectedBranchCode;
    if (!branchCode) return;

    // if (!header.BranchCode) return;

  let cancelled = false;

  const t = setTimeout(async () => {
    setWarehouseLoading(true);
    try {
      const data = await apiFetchWarehouseMaster({ 
        compID,  
        branchCode,
        q: warehouseQuery || "",
        });
    
      if (cancelled) return;
      const opts = data?.success && Array.isArray(data.options) ? data.options : [];

      setWarehouseOptions(opts);
    } catch (e) {
      console.error(e);
      if (!cancelled) setWarehouseOptions([]);
    } finally {
      if (!cancelled) setWarehouseLoading(false);
    }
  }, 300);

  return () => {
    cancelled = true;
    clearTimeout(t);
  };
}, [compID, header.BranchCode, selectedBranchCode, warehouseQuery]);
 

useEffect(() => {

    // const branchCode = header.BranchCode || selectedBranchCode;
    // if (!branchCode) return;

      let cancelled = false;

  const t = setTimeout(async () => {
    setVatAtcLoading(true);
   try {
      const [vatRes, nonVatRes] = await Promise.all([
        apiFetchVATATC({ compID, taxType: "VAT", q: "" }),
        apiFetchVATATC({ compID, taxType: "NON-VAT", q: "" }),
      ]);
      
      if (cancelled) return;
 
        setVatAtcOptionsVAT(
        vatRes?.success && Array.isArray(vatRes.options) ? vatRes.options : []
        );
        setVatAtcOptionsNonVat(
        nonVatRes?.success && Array.isArray(nonVatRes.options) ? nonVatRes.options : []
        );

    } catch (e) {
      console.error(e);
 
      if (!cancelled)  
      {
        setVatAtcOptionsVAT([]);
        setVatAtcOptionsNonVat([]);
      }
    } finally {
   
       if (!cancelled) setVatAtcLoading(false);
    }
  }, 300);  
 
     return () => {
    cancelled = true;
  };
}, [compID, header.BranchCode, selectedBranchCode]);


useEffect(() => {
  if (
    !viewMode &&
    !saleHeader.Warehouse &&
    Array.isArray(warehouseOptions) &&
    warehouseOptions.length > 0
  ) {
    const first = warehouseOptions[0];

    setSaleHeader((p) => ({
      ...p,
      Warehouse: first,
    }));

    setWarehouseQuery(`${first.Code} - ${first.Description}`);
  }
}, [warehouseOptions, viewMode, saleHeader.Warehouse]);


const VATABLE_OPTIONS  = [
  { code: "Exempt", label: "Exempt from Vat", rate: "0" },
  { code: "Taxable", label: "12% Vatable", rate: "12.00" },
  { code: "Zero", label: "Zero Rated VAT", rate: "0" },
];

const NON_VAT_OPTIONS = [
  { code: "NON-VAT", label: "NON-VAT",rate: "0" },
];

function VATCodeEditCell(props) {
  const { row } = props;

    const isVatable =
    row.VATable === true || row.VATable === 1 || row.VATable === "true"|| row.VATable === "yes";

    const options = isVatable ? VATABLE_OPTIONS : NON_VAT_OPTIONS;

  return (
  <GridEditSingleSelectCell
      {...props}
      valueOptions={options}
    />
  );
}

function VATATCEditCell(props) {
  const { id, field, row, value } = props;
  const apiRef = useGridApiContext();

  
  const vatable =
    row?.VATable === true || row?.VATable === 1 || row?.VATable === "true"|| row?.VATable === "yes";

  const options =   vatable ? ["Taxable", "Exempt", "Zero"] : ["NON-VAT"];

  
   return (
    <Select
      fullWidth
      size="small"
      value= {options.includes(value) ? value : options[0]}
      onChange={(e) => {
        apiRef.current.setEditCellValue({
          id,
          field,
          value: e.target.value,
        });
      }}
      autoFocus
    >
      {options.map((opt) => (
        <MenuItem key={opt} value={opt}>
          {opt}
        </MenuItem>
      ))}
    </Select>
  );
}


  const setField = (name, value) => setHeader((prev) => ({ ...prev, [name]: value }));

  const addLine = () => setLines((prev) => [...prev, emptyLine(prev.length + 1)]);

  const [lineSelection, setLineSelection] = useState([]);
  const deleteSelectedLines = (selectedIds) => {
    if (!selectedIds?.length) return;
    setLines((prev) => {
      const kept = prev.filter((r) => !selectedIds.includes(r.id));
      return kept.map((r, idx) => ({ ...r, LineNo: idx + 1 }));
    });
  };
 
  // ✅ CASH dialog opener (forces radio to CASH)
   async function openCashDialog(dlgMode, row = null) {
  setTenderType("CASH");

  let opts = [];
  try {
    const data = await apiFetchFunds({ fundtype: "On Hand" });
    opts = data?.success && Array.isArray(data.options) ? data.options : [];
    setFundOptions(opts);
  } catch (e) {
    console.error(e);
    setFundOptions([]);
  }

  setCashDlgMode(dlgMode);
  setCashEditingId(row?.id ?? null);

  const currentRow = row ?? cashRows[0] ?? null;

  if (!currentRow) {
    setCashForm({ fund: null, amount: "" });
  } else {
    const fund =
      opts.find((f) => f.FundCode === currentRow.FundCode) ?? {
        FundCode: currentRow.FundCode,
        FundName: currentRow.FundName,
      };
    setCashForm({ fund, amount: String(currentRow.CashAmount ?? "") });
  }

  setCashDlgOpen(true);
}


  // ✅ CHECK dialog opener (forces radio to CHECK)
 async function openCheckDialog(dlgMode, row = null) {
      setTenderType("CHECK"); // auto-switch

      // for single-record setup: if no row passed, use existing single row (if any)
      const currentRow = row ?? checkRows[0] ?? null;

      // 1) Load "In Bank" funds
      let inBankFunds = [];
      try {
        const data = await apiFetchFunds({ fundtype: "In Bank" });
        inBankFunds = (data?.success && Array.isArray(data.options)) ? data.options : [];
        //setFundOptions(inBankFunds);
        setBankFundOptions(inBankFunds);   // ✅ this populates the dropdown

      } catch (e) {
        console.error(e);
        setBankFundOptions([]); 
        //setFundOptions([]);
      }

      setCheckDlgMode(dlgMode);
      setCheckEditingId(currentRow?.id ?? null);

      // 2) ADD mode (no existing row)
      if (!currentRow) {
        setCheckForm({
          bankFund: null,   // ✅ new
          bank: null,
          bankBranch: "",
          checkNumber: "",
          checkDate: new Date(),
          amount: "",
          depositDate: new Date(),
        });
        setCheckDlgOpen(true);
        return;
      }

      // 3) EDIT/CLONE mode (existing row)
      // Prefer fund lookup by FundCode from row; fallback to null
      const bankFund =
        inBankFunds.find((f) => f.FundCode === currentRow.FundCode) ??
        null;

      // Auto-fill bank fields based on fund (recommended)
      const bankFromFund = bankFund?.BankCode
        ? {
            BankCode: bankFund.BankCode,
            BankName: bankFund.BankName ?? bankFund.BankCode,
           // BankBranch: bankFund.BankBranch ?? "",
          }
        : {
            // fallback to row values if fund has no bank info
            BankCode: currentRow.BankCode ?? "",
            BankName: currentRow.BankName ?? "",
           // BankBranch: currentRow.BankBranch ?? "",
          };

      setCheckForm({
        bankFund, // ✅ new
        bank: bankFromFund,
        //bankBranch: bankFromFund.BankBranch ?? "",
        bankBranch: currentRow.BankBranch ?? "",
        checkNumber: currentRow.CheckNumber ?? "",
        checkDate: currentRow.CheckDate ? new Date(currentRow.CheckDate) : new Date(),
        amount: String(currentRow.CheckAmount ?? ""),
        depositDate: currentRow.DepositDate ? new Date(currentRow.DepositDate) : new Date(),
      });

      setCheckDlgOpen(true);
    }

  // ✅ Single-row save
  const saveCash = () => {
    const fund = cashForm.fund;
    const amount = Number(cashForm.amount);

    if (!fund?.FundCode) return alert("Please select Fund.");
    if (!Number.isFinite(amount) || amount <= 0) return alert("Cash amount must be greater than zero.");

    const payload = {
      FundCode: fund.FundCode,
      FundName: fund.FundName ?? "",
      CashAmount: amount,
    };

    setCashRows((rows) => cashDlgMode === "edit"
      ? rows.map((row) => row.id === cashEditingId ? { ...row, ...payload } : row)
      : [...rows, { id: uid(), ...payload }]);

    setCashDlgOpen(false);
  };

   const saveCheck = () => {
  const bankFund = checkForm.bankFund;     // ✅ required now
  const bank = checkForm.bank;             // auto-filled (optional fallback)
  const amount = Number(checkForm.amount);

  if (!bankFund?.FundCode) return alert("Please select Bank Fund (In Bank).");
   if (!checkForm.bankBranch) return alert("Please enter check bank and branch info");
  if (!checkForm.checkNumber) return alert("Please enter Check/Ref No.");
  if (!checkForm.checkDate) return alert("Please select Check Date.");
  if (!Number.isFinite(amount) || amount <= 0) return alert("Invalid check amount.");
  if (!checkForm.depositDate) return alert("Please select deposit date.");

  // Prefer mapping from fund; fallback to selected bank object
  const BankCode = bankFund.BankCode || bank?.BankCode || "";
  const BankName = bankFund.BankName || bank?.BankName || "";
  //const BankBranch = checkForm.BankBranch || checkForm.bankBranch || bank?.BankBranch || "";

  if (!BankCode) return alert("Selected Bank Fund has no Bank mapping (BankCode).");

  const payload = {
    // ✅ new fund field (store it so you can re-open and know which fund was used)
    FundCode: bankFund.FundCode,
    FundName: bankFund.FundName ?? "",

    // ✅ bank fields (auto from fund)
    BankCode,
    BankName,
    BankBranch: checkForm.bankBranch,

    CheckNumber: checkForm.checkNumber,
    CheckDate: checkForm.checkDate,
    CheckAmount: amount,
    DepositDate: checkForm.depositDate,
  };

  setCheckRows((rows) => checkDlgMode === "edit"
    ? rows.map((row) => row.id === checkEditingId ? { ...row, ...payload } : row)
    : [...rows, { id: uid(), ...payload }]);

  setCheckDlgOpen(false);
};
  const validate = () => {
    if (!header.BranchCode) return "Branch is required.";
    if (!isValidDate(header.TransDate)) return "Enter a valid transaction date.";
    if (!header.PayorName?.trim()) return "Payor name is required.";
    if (!header.PayorID) return "Select a valid customer/payor from the list.";
    if (collectedTotal <= 0) return "Please enter Cash/Check collection.";
    if (checkRows.some((row) => !isValidDate(row.CheckDate) || !isValidDate(row.DepositDate))) return "Enter valid check and deposit dates.";
    if (saleLines.length && saleHeader.SIDate && !isValidDate(saleHeader.SIDate)) return "Enter a valid SI date.";
    if (saleLines.length && saleHeader.DRDate && !isValidDate(saleHeader.DRDate)) return "Enter a valid DR date.";
    if ((Number(header.TotalAmount) || 0) <= 0) return "Total amount must be greater than 0.";
    return null;
  };

  const handleSave = async () => {
    const err = validate();
    if (err) return alert(err);

    setSaving(true);
    try {
      const payload = {
        compID,
        userID,
        mode,
        header: {
          ...header,
          TotalAmount: Number(header.TotalAmount) || 0,
          UnappliedAmount: Number(header.UnappliedAmount) || 0,
          CashTotal: cashTotal,
          CheckTotal: checkTotal,
          CollectedTotal: collectedTotal,
        },

        cashRows,
        checkRows,

        lines: lines.map((r, idx) => ({
          ...r,
          LineNo: idx + 1,
          InvoiceAmount: Number(r.InvoiceAmount) || 0,
          AppliedAmount: Number(r.AppliedAmount) || 0,
        })),
        saleHeader: {
          ...saleHeader,
          WarehouseCode: saleHeader.Warehouse?.Code || "",
          WTATC: saleHeader.ATC?.ATC || "",
          WTRate: Number(saleHeader.ATC?.Rate) || 0,
          WTAmount: saleTotals.withholdingTaxAmount,
          totals: saleTotals,
        },
        saleLines: saleLines.map((r, idx) => ({ ...r, LineNo: idx + 1 })),
      };

      const data = await apiSaveTransaction(payload);
      if (!data?.success) return alert(data?.message || "Save failed.");

      setHeader((prev) => ({
        ...prev,
        RecID: data.recid ?? prev.RecID,
        TransNo: data.transNo ?? prev.TransNo,
      }));

      alert("Saved!");
    } catch (e) {
      console.error(e);
      alert("Server error on save.");
    } finally {
      setSaving(false);
    }
  };


  //Invoicing
const emptySaleLine = (idx = 1) => ({
  // id: `${Date.now()}-SALE-${idx}`,
    id: uid(),  
  LineNo: idx,
  ItemCode: "",
  Description: "",
  Qty: 1,
  Unit: "",
  UnitPrice: 0,
  Amount: 0,          // Qty * UnitPrice (auto)
  VATable: false,
  VatCode: "",
  VATAmount: 0,
  VATRate: 0,
  VATATC: 0,
  NetUnitPrice: 0,
  UnitBase: "",
  UnitFactor: 1,
  GLCode: "",
  IncomeAccount: "",
  SalesType  : "",
  InvCost: 0,
  CPU: 0,
  COSGLCode: "",
  RegType: "",

 
});


const [goodsItemLines, setGoodsItemLines] = useState({});

 
const [saleLines, setSaleLines] = useState([]);
 const saleTotals = useMemo(() => {
  const totalGross = saleLines.reduce((s, r) => s + (toNumber(r.Amount) || 0), 0);
  const totalVat = saleLines.reduce((s, r) => s + (toNumber(r.VATAmount) || 0), 0);
  const totalQty = saleLines.reduce((s, r) => s + (toNumber(r.Qty) || 0), 0);
  const totalItems = saleLines.filter(r => (r.ItemCode || r.Description || "").trim()).length;
  const rate = saleHeader.WithATC ? (toNumber(saleHeader.ATC?.Rate) || 0) : 0;
    const netAmount = totalGross - totalVat; // OR totalGross - vat depending on your definition
  const withholdingTaxAmount = netAmount * (rate / 100);
 const amountDue = totalGross - withholdingTaxAmount;
 
  return { totalGross, totalVat, totalQty, totalItems, netAmount, withholdingTaxAmount, amountDue };
}, [saleLines, saleHeader.WithATC, saleHeader.ATC]);


const [saleSelection, setSaleSelection] = useState([]);

const addSaleLine = () => setSaleLines((prev) => [...prev, emptySaleLine(prev.length + 1)]);

const deleteSelectedSaleLines = () => {
  if (!saleSelection?.length) return;

  const selectedSet = new Set(saleSelection.map(String));

  setSaleLines((prev) => {
    const kept = prev.filter((r) => !selectedSet.has(String(r.id)));
    return kept.map((r, idx) => ({ ...r, LineNo: idx + 1 }));
  });

  setSaleSelection([]); // clear selection after delete
};



  





///Invoicing

// const selectedItemObj = useMemo(() => {
//     if (!goodsItemLines) return null;
//     return itemOptions1.find((p) => p.goodsItemLines === goodsItemLines) || null;
//   }, [itemOptions1, goodsItemLines]);


  const handlePost = async () => {
    const recID = header.RecID || recid;
    if (!recID) return alert("Save first before posting.");
    if (!window.confirm("Post this transaction?")) return;

    setSaving(true);
    try {
      const data = await apiPostTransaction(recID);
      if (!data?.success) return alert(data?.message || "Post failed.");
      setField("Status", "Posted");
      alert("Posted!");
    } catch (e) {
      console.error(e);
      alert("Server error on post.");
    } finally {
      setSaving(false);
    }
  };

  const handleUnpost = async () => {
    const recID = header.RecID || recid;
    if (!recID) return alert("Missing RecID.");
    if (!window.confirm("Unpost this transaction?")) return;

    setSaving(true);
    try {
      const data = await apiUnpostTransaction(recID);
      if (!data?.success) return alert(data?.message || "Unpost failed.");
      setField("Status", "Unposted");
      alert("Unposted!");
    } catch (e) {
      console.error(e);
      alert("Server error on unpost.");
    } finally {
      setSaving(false);
    }
  };

  const statusChip = useMemo(() => {
    const s = String(header.Status || "").toLowerCase();
    const label = header.Status || "Unknown";
    if (s === "posted") return <Chip label={label} color="success" size="small" />;
    if (s === "cancelled") return <Chip label={label} color="default" size="small" />;
    return <Chip label={label} color="primary" size="small" />;
  }, [header.Status]);

  const handleBack = () => {
    if (onClose) return onClose();
    navigate("/App/TLCashReceipts");
  };

 
const onRowUpdateError = (err) => {
  console.error("Row update error:", err);
  alert("Failed to update row. Check console.");
};

const processSaleRowUpdate = (newRow) => {
  const qty = Number(newRow.Qty) || 0;
  const unitPrice = Number(newRow.UnitPrice) || 0;
  const VatRate1 = Number(newRow.VATRate) || 0;
  const InventoryCost1 = toNumber(newRow.CostPerUnit) || 0;
 
  const isVatable =
  newRow.VATable === true || newRow.VATable === 1 || newRow.VATable === "true"|| newRow.VATable === "yes";
  
  const rawVatRate = toNumber("12.00");

  const allowedVatableCodes = ["Taxable", "Exempt", "Zero"];

  let vatCode = String(newRow.VatCode || "").trim();

 
  if (!isVatable) {
    vatCode = "NON-VAT";
  } else {
    if (!allowedVatableCodes.includes(vatCode)) vatCode = "Taxable";
  }

 
  const vatRate = 
  !isVatable || vatCode === "NON-VAT" || vatCode === "Exempt" || vatCode === "Zero"
    ? 0
    : rawVatRate;

  // Compute amounts
  const gross = qty * unitPrice;

  // Your formula assumes UnitPrice is VAT-inclusive when vatRate > 0
  const vatAmount =
    vatRate > 0 ? (gross / (1 + vatRate / 100)) * (vatRate / 100) : 0;

  const netUnitPrice =
    vatRate > 0 ? unitPrice / (1 + vatRate / 100) : unitPrice;

  const inventoryCost1 = toNumber(newRow.CostPerUnit);
  const invCost = inventoryCost1 * qty;


  // const fixed = {
  //   ...newRow,
  //   Qty: fmt2(qty),
  //   UnitPrice: fmt2(unitPrice),
  //   Amount: fmt2(qty * unitPrice),
  //  // VATAmount: (VatRate1|| 0) ? fmt2(((qty * unitPrice) / (1+((VatRate1)/100))) * ((VatRate1)/100))   : 0,
  //   VATAmount: vatRate > 0 ? fmt2(vatAmount) : 0,
  //  // NetUnitPrice: fmt2(unitPrice / (1+((VatRate1)/100))) || 0,
  //   NetUnitPrice: fmt2(netUnitPrice),
  //     InvCost: fmt2(invCost),
  //  // InvCost: fmt2(InventoryCost1*qty),
   
 
  // };
  const fixed = {
    ...newRow,
    VATable: isVatable,

    Qty: fmt2(qty),
    UnitPrice: fmt2(unitPrice),
    Amount: fmt2(gross),

    VatCode: vatCode,
    VATRate: vatRate,
    VATAmount: vatRate > 0 ? fmt2(vatAmount) : 0,
    NetUnitPrice: fmt2(netUnitPrice),

    InvCost: fmt2(invCost),
  };
  

  // if (!fixed.VATable) {
  //   fixed.VatCode = "NON-VAT";
  //   fixed.VATRate = 0;
  //   fixed.VATAmount = 0;
  //   fixed.NetUnitPrice = fmt2(unitPrice);   
  // }
 
  //   if (fixed.VATable) {
  //   fixed.VatCode = "Taxable";
  //   fixed.VATRate = VatRate1;
  //   fixed.VATAmount =  (VatRate1|| 0) ? fmt2(((qty * unitPrice) / (1+((VatRate1)/100))) * ((VatRate1)/100))   : 0;
  //   fixed.NetUnitPrice = fmt2(unitPrice / (1+((VatRate1)/100))) || 0;   
  // }
 

  setSaleLines((prev) => prev.map((r) => (r.id === fixed.id ? fixed : r)));
  return fixed;
};


 
const addPickedItemToSaleLines = (item) => {
  if (!item?.ItemCode) return alert("Select an item first.");
  const qty = Number(entryQty) || 1;

  // decide price: user entry > item default > 0
  // const unitPrice = Number(entryPrice) || Number(item.UnitPrice) || 0;
  const unitPrice = Number(entryPrice)||0;

  const newRow = {
    ...emptySaleLine(1),          // gives defaults
    id: uid(),
    ItemCode: item.ItemCode,
    Description: item.Description ?? "",
    Unit: item.Unit ?? "",
    Qty: qty,
    UnitPrice: fmt2(unitPrice),
    Amount: fmt2(qty * unitPrice),
    VATable: item.Vatable, // or keep your default
    VatCode: item.VATCode ?? "",
    VATRate: Number(item.VatRate) || 0,
    // if you want to compute VATAmount:
    VATATC: item.VatATC ?? "",
    VATAmount: (fmt2(item.VatRate) || 0) ? fmt2(((qty * unitPrice) / (1+((item.VatRate)/100))) * ((item.VatRate)/100))   : 0,
   // VATAmount: (((qty * unitPrice)) / ((1+((item.VatRate)/100))))  ,
    // hidden fields if you have them from API:
    //NetUnitPrice: Number(item.NetUnitPrice) || 0,
    NetUnitPrice: fmt2(unitPrice / (1+((item.VatRate)/100))) || 0,
    UnitBase: item.UnitBase ?? "",
    UnitFactor: Number(item.UnitFactor) || 1,
    GLCode: item.GLCode ?? "",
    IncomeAccount: item.IncomeAccount ?? "",
    SalesType: item.SalesType ?? "",
    InvCost: fmt2(((item.InventoryCost) || 0.00) *  (((qty * unitPrice) / (1+((item.VatRate)/100))))),
    CostPerUnit: fmt2(((item.InventoryCost) || 0.00) *  (((qty * unitPrice) / (1+((item.VatRate)/100))))),
    COSGLCode: item.CostGLCode ?? "",
    RegType: item.RegType ?? "",
  };

 
  setSaleLines((prev) => {
  const hasBlankLast =
    prev.length > 0 &&
    !String(prev[prev.length - 1].ItemCode || "").trim() &&
    !String(prev[prev.length - 1].Description || "").trim();

  const next = hasBlankLast
    ? [...prev.slice(0, -1), newRow]   // ✅ replace blank last row
    : [...prev, newRow];
console.log(newRow);
  return next.map((r, idx) => ({ ...r, LineNo: idx + 1 }));
  });

  // reset entry bar
  setPickedItem(null);
  setItemQuery("");
  setEntryQty(1);
  setEntryPrice("");
};

 


  return (
    <Box p={2} sx={{ background: `${colors.greenAccent[900]}` }}>
      <Paper elevation={2} sx={{ p: 2 }}>
        <Stack direction="row" justifyContent="space-between" alignItems="center" spacing={2}>
          <Box>
            <Typography variant="h6">
              Cash Receipt Transaction{" "}
              <Typography component="span" variant="body2" sx={{ ml: 1 }}>
                {statusChip}
              </Typography>
            </Typography>
            <Typography variant="body2" color="text.secondary">
              {mode.toUpperCase()} {recid ? `• RecID: ${recid}` : ""}
            </Typography>
          </Box>

          <Stack direction="row" spacing={1}>
            <Button variant="outlined" onClick={handleBack}>
              Back
            </Button>

            <Button variant="contained" onClick={handleSave} disabled={viewMode || saving || loading}>
              {saving ? "Saving..." : "Save"}
            </Button>

            <Button
              variant="contained"
              color="success"
              onClick={handlePost}
              disabled={viewMode || saving || loading || String(header.Status).toLowerCase() === "posted"}
            >
              Post
            </Button>

            <Button
              variant="contained"
              color="warning"
              onClick={handleUnpost}
              disabled={viewMode || saving || loading || String(header.Status).toLowerCase() !== "posted"}
            >
              Unpost
            </Button>
          </Stack>
        </Stack>

        <Divider sx={{ my: 2 }} />

        {loading ? (
          <Box display="flex" justifyContent="center" py={6}>
            <CircularProgress />
          </Box>
        ) : (
          <>
            {/* HEADER ROW */}
            <Grid container spacing={2} alignItems="center">
              <Grid item xs={12} md={3}>
                <TextField
                  label="Trans Date"
                  type="date"
                  value={header.TransDate}
                  onChange={(e) => setField("TransDate", e.target.value)}
                  fullWidth
                  size="small"
                  disabled={viewMode}
                  InputLabelProps={{ shrink: true }}
                />
              </Grid>

              <Grid item xs={12} md={3}>
                <TextField
                  label="Reference No"
                  value={header.ReferenceNo}
                  onChange={(e) => setField("ReferenceNo", e.target.value)}
                  fullWidth
                  size="small"
                  disabled={viewMode}
                />
              </Grid>

              <Grid item xs={12} md={3}>
                <TextField label="Trans No" value={header.TransNo} fullWidth size="small" disabled />
              </Grid>

              <Grid item xs={12} md={3}>
                <TextField label="Branch" value={branchDisplayName ?? ""} fullWidth size="small" disabled />
              </Grid>
            </Grid>

            <Divider sx={{ my: 2 }} />

            {/* BODY */}
            <Grid container spacing={2} alignItems="flex-start">
              <Grid item xs={12} md={6}>
                <Stack spacing={1.5}>
                  <Autocomplete
                    options={payorOptions}
                    loading={payorLoading}
                    value={selectedPayorObj}
                    inputValue={payorQuery}
                    getOptionLabel={(o) => o?.PayorName ?? ""}
                    isOptionEqualToValue={(o, v) => o?.PayorID === v?.PayorID}
                    onInputChange={(e, v, reason) => {
                      if (reason === "input") setPayorQuery(v);
                    }}
                    onChange={(e, nv) => {
                      setHeader((prev) => ({
                        ...prev,
                        PayorID: nv?.PayorID ?? null,
                        PayorName: nv?.PayorName ?? "",
                        PayorInfo: nv?.PayorInfo ?? "",
                      }));
                      setPayorQuery(nv?.PayorName ?? "");
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Payor Name"
                        size="small"
                        disabled={viewMode}
                        InputProps={{
                          ...params.InputProps,
                          endAdornment: (
                            <>
                              {payorLoading ? <CircularProgress size={18} /> : null}
                              {params.InputProps.endAdornment}
                            </>
                          ),
                        }}
                      />
                    )}
                  />

                  <TextField
                    label="Payor Info"
                    value={header.PayorInfo ?? ""}
                    fullWidth
                    sx={{ width: 600 }}
                    size="small"
                    multiline
                    minRows={2}
                    disabled
                  />

                  <TextField
                    label="Remarks"
                    value={header.Remarks}
                    onChange={(e) => setField("Remarks", e.target.value)}
                    fullWidth
                    size="small"
                    multiline
                    minRows={2}
                    disabled={viewMode}
                  />
                </Stack>
              </Grid>

              <Grid item xs={12} md={3}>
                <Stack spacing={1.5}>
                  <TextField
                    label="Collected"
                    value={Number(header.TotalAmount || 0).toLocaleString(undefined, {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    })}
                    fullWidth
                    size="small"
                    disabled
                    inputProps={{ style: { textAlign: "right"} }}
                  />
                  <TextField
                    label="Invoiced"
                    value={Number(header.InvoicedAmount || 0).toLocaleString(undefined, {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    })}
                    fullWidth
                    size="small"
                    disabled
                    inputProps={{ style: { textAlign: "right" } }}
                  />
                  <TextField
                    label="Applied"
                    value={Number(totals.totalApplied || 0).toLocaleString(undefined, {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    })}
                    fullWidth
                    size="small"
                    disabled
                    inputProps={{ style: { textAlign: "right" } }}
                  />
                </Stack>
              </Grid>

              <Grid item xs={12} md={3}>
                <Stack spacing={1.5}>
                  <TextField
                    label="Tax Withheld"
                    value={Number(header.TaxWithheld || 0).toLocaleString(undefined, {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    })}

                    fullWidth
                    size="small"
                    disabled
                    inputProps={{ style: { textAlign: "right" } }}
                  />
                  <TextField
                    label="Dr. Adj"
                    value={Number(header.DrAdj || 0).toLocaleString(undefined, {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    })}
                    fullWidth
                    size="small"
                    disabled
                    inputProps={{ style: { textAlign: "right" } }}
                  />
                  <TextField
                    label="Cr. Adj"
                    value={Number(header.CrAdj || 0).toLocaleString(undefined, {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    })}
                    fullWidth
                    size="small"
                    disabled
                    inputProps={{ style: { textAlign: "right" } }}
                  />
                </Stack>
              </Grid>
            </Grid>

            <Divider sx={{ my: 2 }} />

            <Tabs value={tab} onChange={(e, v) => setTab(v)} sx={{ mb: 2 }}>
              <Tab label="Cash Fund" />
              <Tab label="Applications / Details" />
              <Tab label="Sale of Goods" />  
            </Tabs>

            {/* ✅ CASH FUND TAB: RADIO + SINGLE CARD VIEW */}
            {tab === 0 && (
              <>
                <Grid container spacing={2} sx={{ mb: 2 }}>
                  <Grid item xs={12} md={4}>
                    <TextField 
                    label="Cash Total" 
                    value={Number(cashTotal|| 0).toLocaleString(undefined, {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    })}
                    fullWidth 
                    size="small" 
                    disabled 
                    inputProps={{ style: { textAlign: "right" } }}
                    />
                  </Grid>
                  <Grid item xs={12} md={4}>
                    <TextField label="Check Total" 
                     value={Number(checkTotal|| 0).toLocaleString(undefined, {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    })}
                    fullWidth 
                    size="small" 
                    disabled 
                    inputProps={{ style: { textAlign: "right" } }}
                    />
                  </Grid>
                  <Grid item xs={12} md={4}>
                    <TextField 
                    label="Collected Total" 
                     value={Number(collectedTotal|| 0).toLocaleString(undefined, {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    })}

                    fullWidth 
                    size="small" 
                    disabled 
                    inputProps={{ style: { textAlign: "right" } }}
                    />
                  </Grid>
                </Grid>

                <FormControl sx={{ mb: 2 }}>
                  <RadioGroup
                    row
                    value={tenderType}
                    onChange={(e) => setTenderType(e.target.value)}
                  >
                    <FormControlLabel value="CASH" control={<Radio />} label="Cash" disabled={viewMode} />
                    <FormControlLabel value="CHECK" control={<Radio />} label="Check" disabled={viewMode} />
                  </RadioGroup>
                </FormControl>

                {tenderType === "CASH" && (
                  <Card variant="outlined">
                    <CardContent>
                      <Typography variant="subtitle1" sx={{ mb: 1 }}>
                        Cash Detail
                      </Typography>

                      {!cashRows.length ? (
                        <Typography variant="body2" color="text.secondary">
                          No cash entry yet.
                        </Typography>
                      ) : (
                        <Grid container spacing={2}>
                          <Grid item xs={12} md={6}>
                            <Typography variant="body2" color="text.secondary">Fund</Typography>
                            <Typography variant="body1">
                              {cashRows[0].FundCode} - {cashRows[0].FundName}
                            </Typography>
                          </Grid>
                          <Grid item xs={12} md={6}>
                            <Typography variant="body2" color="text.secondary">Amount</Typography>
                            <Typography variant="body1">
                              {Number(cashRows[0].CashAmount || 0).toLocaleString(undefined, {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                              })}
                            </Typography>
                          </Grid>
                        </Grid>
                      )}
                    </CardContent>

                    <CardActions>
                      {!cashRows.length ? (
                        <Button
                          startIcon={<AddIcon />}
                          variant="contained"
                          onClick={() => openCashDialog("add")}
                          disabled={viewMode}
                        >
                          Add Cash
                        </Button>
                      ) : (
                        <>
                          <Button
                            startIcon={<EditIcon />}
                            variant="outlined"
                            onClick={() => openCashDialog("edit", cashRows[0])}
                            disabled={viewMode}
                          >
                            Edit
                          </Button>
                          <Button
                            startIcon={<DeleteIcon />}
                            variant="outlined"
                            color="error"
                            onClick={() => setCashRows([])}
                            disabled={viewMode}
                          >
                            Remove
                          </Button>
                        </>
                      )}
                    </CardActions>
                  </Card>
                )}

                {tenderType === "CHECK" && (
                  <Card variant="outlined">
                    <CardContent>
                      <Typography variant="subtitle1" sx={{ mb: 1 }}>
                        Check Detail
                      </Typography>

                      {!checkRows.length ? (
                        <Typography variant="body2" color="text.secondary">
                          No check entry yet.
                        </Typography>
                      ) : (
                        <Grid container spacing={2}>
                        
                          <Grid item xs={12} md={6}>
                            <Typography variant="body2" color="text.secondary">Bank/Branch</Typography>
                            <Typography variant="body1">{checkRows[0].BankBranch}</Typography>
                          </Grid>
                          <Grid item xs={12} md={6}>
                            <Typography variant="body2" color="text.secondary">Check/Ref No.</Typography>
                            <Typography variant="body1">{checkRows[0].CheckNumber}</Typography>
                          </Grid>
                          <Grid item xs={12} md={6}>
                            <Typography variant="body2" color="text.secondary">Check Date</Typography>
                            <Typography variant="body1">
                              {checkRows[0].CheckDate ? new Date(checkRows[0].CheckDate).toLocaleDateString() : ""}
                            </Typography>
                          </Grid>
                          <Grid item xs={12} md={6}>
                            <Typography variant="body2" color="text.secondary">Amount</Typography>
                            <Typography variant="body1">
                              {Number(checkRows[0].CheckAmount || 0).toLocaleString(undefined, {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                              })}
                            </Typography>
                          </Grid>
                            <Grid item xs={12} md={6}>
                            <Typography variant="body2" color="text.secondary">Depository Bank</Typography>
                            <Typography variant="body1">
                              {checkRows[0].BankCode} - {checkRows[0].BankName}
                            </Typography>
                          </Grid>
                          <Grid item xs={12} md={6}>
                            <Typography variant="body2" color="text.secondary">Deposit Date</Typography>
                            <Typography variant="body1">
                              {checkRows[0].DepositDate ? new Date(checkRows[0].DepositDate).toLocaleDateString() : ""}
                            </Typography>
                          </Grid>


                        </Grid>
                      )}
                    </CardContent>

                    <CardActions>
                      {!checkRows.length ? (
                        <Button
                          startIcon={<AddIcon />}
                          variant="contained"
                          onClick={() => openCheckDialog("add")}
                          disabled={viewMode}
                        >
                          Add Check
                        </Button>
                      ) : (
                        <>
                          <Button
                            startIcon={<EditIcon />}
                            variant="outlined"
                            onClick={() => openCheckDialog("edit", checkRows[0])}
                            disabled={viewMode}
                          >
                            Edit
                          </Button>
                          <Button
                            startIcon={<DeleteIcon />}
                            variant="outlined"
                            color="error"
                            onClick={() => setCheckRows([])}
                            disabled={viewMode}
                          >
                            Remove
                          </Button>
                        </>
                      )}
                    </CardActions>
                  </Card>
                )}
              </>
            )}

            {/* APPLICATIONS TAB (unchanged) */}
            {tab === 1 && (
              <>
                <Stack direction="row" justifyContent="space-between" alignItems="center" mb={1}>
                  <Typography variant="subtitle1">Applications / Details</Typography>

                  <Stack direction="row" spacing={1}>
                    <Button variant="outlined" onClick={addLine} disabled={viewMode}>
                      Add line
                    </Button>
                     <Button
                      variant="outlined"
                      color="error"
                      // onClick={deleteSelectedSaleLines}
                     // onClick={() => deleteSelectedLines(lineSelection)}
                     // disabled={viewMode || saleSelection.length === 0}
                      onClick={() => deleteSelectedLines(lineSelection)}
                      disabled={viewMode || lineSelection.length === 0}
                    >
                      Delete selected
                    </Button>
                  </Stack>
                </Stack>

                <Box height={320}>
                  <DataGrid
                    rows={lines}
                    columns={appColumns}
                    disableRowSelectionOnClick
                    checkboxSelection={!viewMode}
                    rowSelectionModel={{ type: "include", ids: new Set(lineSelection) }}
                    onRowSelectionModelChange={(model) => setLineSelection(Array.from(model?.ids || []))}
                    processRowUpdate={(newRow) => {
                      const fixed = {
                        ...newRow,
                        InvoiceAmount: Number(newRow.InvoiceAmount) || 0,
                        AppliedAmount: Number(newRow.AppliedAmount) || 0,
                      };
                      setLines((prev) => prev.map((r) => (r.id === fixed.id ? fixed : r)));
                      return fixed;
                    }}
                  />
                </Box>

                <Divider sx={{ my: 2 }} />

                <Grid container spacing={2}>
                  <Grid item xs={12} md={4}>
                    <TextField label="Total Applied" value={totals.totalApplied} fullWidth size="small" disabled />
                  </Grid>
                  <Grid item xs={12} md={4}>
                    <TextField label="Unapplied Amount" value={totals.unapplied} fullWidth size="small" disabled />
                  </Grid>
                  <Grid item xs={12} md={4}>
                    <TextField label="Status" value={header.Status} fullWidth size="small" disabled />
                  </Grid>
                </Grid>
              </>
            )}
            {tab === 2 && (
            <>
              <Stack direction="row" justifyContent="space-between" alignItems="center" mb={1}>
                {/* <Typography variant="subtitle1">Sale of Goods</Typography> */}
           
                 <Stack  direction="row" spacing={1} mb={1}>
                  <Autocomplete
                    options={itemOptions1}
                    loading={itemLoading1}
                    value={pickedItem}
                    inputValue={itemQuery}
                    getOptionLabel={(o) => (o ? `${o.ItemCode} - ${o.Description}` : "")}
                    isOptionEqualToValue={(o, v) => o?.ItemCode === v?.ItemCode}
                    onInputChange={(e, v, reason) => {
                      if (reason === "input") setItemQuery(v);
                    }}
                    onChange={(e, nv) => {
                      setPickedItem(nv);
                      setItemQuery(nv ? `${nv.ItemCode} - ${nv.Description}` : "");
                      setEntryPrice(nv.UnitPrice||"1");
                      setEntryQty(nv.Qty||"1");
                      // OPTIONAL: auto-add immediately when selected
                      // if (nv) addPickedItemToSaleLines(nv);
                    }}
                    renderInput={(params) => (
                      <TextField {...params} label="Search Items" size="small" sx={{ width: 600 }} />
                    )}

                    onKeyDown={(e) => {
                      if (e.key === "Enter") {
                        e.preventDefault();
                        if (pickedItem) addPickedItemToSaleLines(pickedItem);
                      }
                    }}
                  />

                 
    
               <TextField
                  label="Qty"
                  value={entryQty}
                  onChange={(e) => setEntryQty(Number(e.target.value) || 0)}
                  type="number"
                  size="small"
                  sx={{ width: 100 }}
                  inputProps={{ min: 1 }}
                />

                <TextField
                  label="Unit Price"
                  value={entryPrice}
                  onChange={(e) => setEntryPrice(e.target.value)}
                  type="number"
                  size="small"
                  sx={{ width: 140 }}
                />

                <Button
                    variant="contained"
                    onClick={() => addPickedItemToSaleLines(pickedItem)}
                    disabled={viewMode || !pickedItem}
                  >
                    Add
                  </Button>    
              
              </Stack>
    
                <Stack direction="row" spacing={1}>
                  {/* <Button variant="outlined" onClick={addSaleLine} disabled={viewMode}>
                    Add line
                  </Button>
                  <Button
                    variant="outlined"
                    color="error"
                    //onClick={() => deleteSelectedSaleLines(saleSelection)}
                    //  onClick={() => deleteSelectedLines(lineSelection)}
                    onClick={deleteSelectedSaleLines}
                    disabled={viewMode || saleSelection.length === 0}
                  >
                    Delete selected
                  </Button> */}
                   <Autocomplete
                    
                      options={warehouseOptions}
                      loading={warehouseLoading}
                      value={saleHeader.Warehouse}
                      inputValue={warehouseQuery}
                      disabled={viewMode}
                      onInputChange={(e, v, reason) => {
                        if (reason === "input") setWarehouseQuery(v);
                      }}
                      //onChange={(e, v) => setSaleHeader((p) => ({ ...p, Warehouse: v }))}
                      onChange={(e, v) => {
                        setSaleHeader((p) => ({ ...p, Warehouse: v }));
                        setWarehouseQuery(v ? `${v.Code} - ${v.Description}` : "");
                      }}
                      getOptionLabel={(o) => (o ? `${o.Code} - ${o.Description}` : "")}
                      isOptionEqualToValue={(o, v) => o?.Code === v?.Code}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label="Search Warehouse"
                          size="small"
                           InputProps={{
                             ...params.InputProps,
                           endAdornment: (
                              <>
                                {warehouseLoading ? <CircularProgress size={18} /> : null}
                                {params.InputProps.endAdornment}
                              </>
                            ),
                          }}
                           sx={{ width: 300 }}
                        />
                      )}
                 
                  />

                </Stack>
              </Stack>

              <Box height={340}>
                <DataGrid
                  rows={saleLines}
                  columns={saleColumnsWithDelete}
                  columnVisibilityModel={saleColumnVisibility}
                  editMode="cell"
                  rowHeight={30}
                  disableRowSelectionOnClick
                  // onCellClick={(params) => {
                    
                  //   if (params.field === "VatCode" && !viewMode) {
                  //     params.api.startCellEditMode({ id: params.id, field: "VatCode" });
                  //   }
                  // }}
                  
                //  checkboxSelection={!viewMode}
                //  rowSelectionModel={saleSelection}
                 // rowSelectionModel={lineSelection}
               //   onRowSelectionModelChange={(ids) => setSaleSelection(ids)}
                  //onRowSelectionModelChange={(ids) => setLineSelection(ids)}
                  processRowUpdate={processSaleRowUpdate}
                  onProcessRowUpdateError={onRowUpdateError}
                />
      
              </Box>

              <Divider sx={{ my: 2 }} />
 
              <Grid container spacing={2}  >
                <Grid item xs={12} md={3} >
                <Stack spacing={1.5}>
                <Grid item xs={12} md={3} >
                  <Stack spacing={1.5} direction={"row"}>
                  <TextField
                    label="SI Number"
                    value={saleHeader.SINo}
                    onChange={(e)=>setSaleHeader(p=>({...p,SINo:e.target.value}))}
                    fullWidth
                    size="small"
                     
                  />
       
                  <LocalizationProvider dateAdapter={AdapterDateFns}>
                    <DatePicker
                      label="SI Date"
                      value={saleHeader.SIDate}
                      onChange={(v) => setSaleHeader((p) => ({ ...p, SIDate: v }))}
                      slotProps={{ textField: { size: "small" } }}
                    
                    />
                  </LocalizationProvider>
                  </Stack>
                 </Grid>
                 <Stack spacing={1.5} direction={"row"}>
                  <TextField
                    label="DR Number"
                    value={saleHeader.DRNo}
                    onChange={(e)=>setSaleHeader(p=>({...p,DRNo:e.target.value}))} 
                    fullWidth
                    size="small"
                     
                  />
                   <LocalizationProvider dateAdapter={AdapterDateFns}>
                    <DatePicker
                      label="DR Date"
                       value={saleHeader.DRDate}
                      onChange={(v) => setSaleHeader((p) => ({ ...p, DRDate: v }))}
                      slotProps={{ textField: {size:"small" } }}
                    
                    />
                  </LocalizationProvider>

                </Stack>
                  <TextField
                    label="Aux Number"
                    value={saleHeader.AuxNo} 
                    onChange={(e)=>setSaleHeader(p=>({...p,AuxNo:e.target.value}))}
                    fullWidth
                    size="small"
                    
                  />

                 
                </Stack>
                </Grid>
            
              <Grid item xs={12} md={3} >
                <Stack spacing={1.5}>
                   {/* <Autocomplete
                    options={Array.isArray(fundOptions) ? fundOptions : []}
                    value={cashForm.fund}
                    onChange={(e, v) => setCashForm((p) => ({ ...p, fund: v }))}
                    getOptionLabel={(o) => (o ? `${o.FundCode} - ${o.FundName}` : "")}
                    isOptionEqualToValue={(o, v) => o?.FundCode === v?.FundCode}
                    renderInput={(params) => 
                    <TextField {...params} label="ATC" size="small" />}
                  /> */}

                  <Stack spacing={1.5} direction={"row"}>
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={!!saleHeader.WithATC}
                          onChange={(e) => {
                            const checked = e.target.checked;
                            setSaleHeader((p) => ({
                              ...p,
                              WithATC: checked,
                              ATC: checked ? p.ATC : null,
                            }));
                            if (!checked) setAtcQuery("");
                          }}
                          disabled={viewMode}
                        />
                      }
                      label="With ATC"
                    />

                        
                    <Autocomplete
                      options={atcOptions}
                      loading={atcLoading}
                      value={saleHeader.ATC}
                      disabled={viewMode || !saleHeader.WithATC}
                      onChange={(e, v) => setSaleHeader((p) => ({ ...p, ATC: v }))}
                      getOptionLabel={(o) => (o ? `${o.ATC} - ${o.Nature}  - ${o.Rate}%` : "")}
                      isOptionEqualToValue={(o, v) => o?.ATC === v?.ATC}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label="Search ATC"
                          size="small"
                           InputProps={{
                             ...params.InputProps,
                           endAdornment: (
                              <>
                                {atcLoading ? <CircularProgress size={18} /> : null}
                                {params.InputProps.endAdornment}
                              </>
                            ),
                          }}
                           sx={{ width: 300 }}
                        />
                      )}
                    />
           
                  </Stack>
                  <Stack spacing={1.5} direction={"row"}>
            
                    <TextField
                      label="ATC"
                      value={saleHeader.ATC?.ATC || ""}
                      fullWidth
                      size="small"
                      disabled
                      required={saleHeader.WithATC}
                    
                    />
                  
                    <TextField
                      label="Wtax Rate"
                      value={saleHeader.ATC ? Number(saleHeader.ATC.Rate || 0).toFixed(2) : "0.00"}
                      fullWidth
                      size="small"
                      disabled
                      inputProps={{ style: { textAlign: "right" } }}
                      required={saleHeader.WithATC}
                    />
                   </Stack>
  
                   <TextField
                    label="Nature"
                    value={saleHeader.ATC?.Nature || ""}
                    fullWidth
                    sx={{ width: 410 }}
                    size="small"
                    multiline
                    minRows={2}
                    disabled 
                    required={saleHeader.WithATC}
                  />
                  
                </Stack>
                </Grid>


              <Grid item xs={12} md={3} >
                <Stack spacing={1.5}>
                  <TextField
                    label="Gross Amount"
                      value={fmt2(saleTotals.totalGross)}
                    fullWidth
                    size="small"
                    disabled
                  inputProps={{ style: { textAlign: "right" } }}
                  />
                   <TextField
                    label="Output Tax"
                      value={fmt2(saleTotals.totalVat)}
                    fullWidth
                    size="small"
                    disabled
                  inputProps={{ style: { textAlign: "right" } }}
                  />
                  <TextField
                    label="Net Amount"
                      value={fmt2(saleTotals.netAmount)}
                    fullWidth
                    size="small"
                    disabled
                  inputProps={{ style: { textAlign: "right" } }}
                  />
                    <TextField
                    label="Wtax Amount"
                      value={fmt2(saleTotals.withholdingTaxAmount) }
                    fullWidth
                    size="small"
                    disabled
                  inputProps={{ style: { textAlign: "right" } }}
                  />
                
                </Stack>
                </Grid>
                <Grid item xs={12} md={3}>
                <Stack spacing={1.5}>
                  <TextField
                    label="Amount Due"
                       value={fmt2(saleTotals.amountDue)}
                    fullWidth
                    size="small"
                    disabled
                  inputProps={{ style: { textAlign: "right" } }}
                  />

                  <TextField
                    label="Total Items"
                     value={saleTotals.totalItems}
                    fullWidth
                    size="small"
                    disabled
                  inputProps={{ style: { textAlign: "right" } }}
                  />
                 <TextField
                    label="Total Qty"
                   value={saleTotals.totalQty}
                    fullWidth
                    size="small"
                    disabled
                  inputProps={{ style: { textAlign: "right" } }}
                  />


                </Stack>
                </Grid>

              </Grid>
               
            </>
          )}


            {/* Cash Dialog */}
            <Dialog open={cashDlgOpen} onClose={() => setCashDlgOpen(false)} maxWidth="sm" fullWidth>
              <DialogTitle>{cashRows.length ? "Edit Cash" : "Add Cash"}</DialogTitle>
              <DialogContent dividers>
                <Stack spacing={2}>
                  <Autocomplete
                    options={Array.isArray(fundOptions) ? fundOptions : []}
                    value={cashForm.fund}
                    onChange={(e, v) => setCashForm((p) => ({ ...p, fund: v }))}
                    getOptionLabel={(o) => (o ? `${o.FundCode} - ${o.FundName}` : "")}
                    isOptionEqualToValue={(o, v) => o?.FundCode === v?.FundCode}
                    renderInput={(params) => <TextField {...params} label="Cash Fund" size="small" />}
                  />
                  <TextField
                    label="Cash Amount"
                    value={cashForm.amount}
                    onChange={(e) => setCashForm((p) => ({ ...p, amount: e.target.value }))}
                    type="number"
                    inputProps={{ step: "0.01" }}
                  />
                </Stack>
              </DialogContent>
              <DialogActions>
                <Button variant="outlined" onClick={() => setCashDlgOpen(false)}>
                  Close
                </Button>
                <Button variant="contained" onClick={saveCash}>
                  Save
                </Button>
              </DialogActions>
            </Dialog>

            {/* Check Dialog */}
            <Dialog open={checkDlgOpen} onClose={() => setCheckDlgOpen(false)} maxWidth="sm" fullWidth>
              <DialogTitle>{checkRows.length ? "Edit Check" : "Add Check"}</DialogTitle>
              <DialogContent dividers>
                <Stack spacing={2}>
               
                  <TextField
                    label="Bank/Branch"
                    value={checkForm.bankBranch}
                    onChange={(e) => setCheckForm((p) => ({ ...p, bankBranch: e.target.value }))}
                  />

                  <TextField
                    label="Check/Ref No."
                    value={checkForm.checkNumber}
                    onChange={(e) => setCheckForm((p) => ({ ...p, checkNumber: e.target.value }))}
                  />

                  <LocalizationProvider dateAdapter={AdapterDateFns}>
                    <DatePicker
                      label="Check Date"
                      value={checkForm.checkDate}
                      onChange={(v) => setCheckForm((p) => ({ ...p, checkDate: v ?? new Date() }))}
                      slotProps={{ textField: { fullWidth: true } }}
                    />
                  </LocalizationProvider>

                  <TextField
                    label="Check Amount"
                    value={checkForm.amount}
                    onChange={(e) => setCheckForm((p) => ({ ...p, amount: e.target.value }))}
                    type="number"
                    inputProps={{ step: "0.01" }}
                  />
                  
                  <Autocomplete
                      options={Array.isArray(bankFundOptions) ? bankFundOptions : []}
                      value={checkForm.bankFund}
                      onChange={(e, v) => {
                        const matchedBank = v?.BankCode
                          ? (bankOptions.find((b) => b.BankCode === v.BankCode) ?? {
                              BankCode: v.BankCode,
                              BankName: v.BankName || "",
                              //BankBranch: v.BankBranch || "",
                            })
                          : null;

                        setCheckForm((p) => ({
                          ...p,
                          bankFund: v,
                          bank: matchedBank,
                         // bankBranch: v?.BankBranch || matchedBank?.BankBranch || "",
                        }));
                      }}
                      getOptionLabel={(o) => (o ? `${o.FundCode} - ${o.FundName}` : "")}
                      isOptionEqualToValue={(o, v) => o?.FundCode === v?.FundCode}
                      renderInput={(params) => (
                        <TextField {...params} label="Depository Bank (In Bank)" size="small" />
                      )}
                    />
                  <Autocomplete
                    options={bankOptions}
                    value={checkForm.bank}
                    disabled
                    getOptionLabel={(o) => (o ? `${o.BankCode} - ${o.BankName}` : "")}
                    isOptionEqualToValue={(o, v) => o?.BankCode === v?.BankCode}
                    renderInput={(params) => <TextField {...params} label="Bank" size="small" />}
                  />
                  
                  <LocalizationProvider dateAdapter={AdapterDateFns}>
                    <DatePicker
                      label="Deposit Date"
                      value={checkForm.depositDate}
                      onChange={(v) => setCheckForm((p) => ({ ...p, depositDate: v ?? new Date() }))}
                      slotProps={{ textField: { fullWidth: true } }}
                    />
                  </LocalizationProvider>


                </Stack>
              </DialogContent>
              <DialogActions>
                <Button onClick={() => setCheckDlgOpen(false)}>Cancel</Button>
                <Button variant="contained" onClick={saveCheck}>
                  Save
                </Button>
              </DialogActions>
            </Dialog>
          </>
        )}
      </Paper>
    </Box>
  );
}
